import React, { useState } from 'react';

const ContactSection = () => {
  const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xgvznpdp';
  const WHATSAPP_NUMBER = '543534199577'; // sin el + ni espacios
  const RECIPIENT_EMAIL = 'contacto@clerko.online';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState(null); // 'sending' | 'success' | 'error'

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');

    try {
      // incluimos _replyto y _to para que Formspree envíe a contacto@clerko.online
      const payload = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        _replyto: formData.email,
        _to: RECIPIENT_EMAIL,
      };

      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('Error en Formspree');

      setStatus('success');

      // Abrir WhatsApp con mensaje prellenado
      const waText = encodeURIComponent(
        `Hola, soy ${formData.name} (${formData.email}):\n\n${formData.message}`
      );
      window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${waText}`, '_blank');

      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <section className="py-16 bg-white" id="contacto">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Contáctanos</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            ¿Listo para llevar tu estudio contable al siguiente nivel? Escríbenos y te responderemos en menos de 24 horas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Formulario */}
          <div className="bg-gray-50 p-8 rounded-xl">
            {status === 'success' && (
              <div className="mb-6 p-4 bg-green-100 text-green-800 rounded">
                ¡Mensaje enviado a {RECIPIENT_EMAIL} y abriendo WhatsApp!
              </div>
            )}
            {status === 'error' && (
              <div className="mb-6 p-4 bg-red-100 text-red-800 rounded">
                Ocurrió un error. Por favor, intenta de nuevo.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nombre</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 transition"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 transition"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Mensaje</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 transition"
                />
              </div>

              <button
                type="submit"
                disabled={status === 'sending'}
                className={`w-full py-3 font-medium rounded-lg shadow-md transition-colors
                  ${status === 'sending'
                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 text-white'}`}
              >
                {status === 'sending' ? 'Enviando...' : 'Enviar mensaje'}
              </button>
            </form>
          </div>

          {/* Contacto estático */}
          <div className="flex flex-col justify-center">
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Información de contacto</h3>
              <p className="text-gray-600 mb-2 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                {RECIPIENT_EMAIL}
              </p>
              <p className="text-gray-600 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                +54 353 4199577
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Horario de atención</h3>
              <p className="text-gray-600 mb-2">Lunes a Viernes: 9:00 - 18:00</p>
              <p className="text-gray-600">Sábados: 10:00 - 13:00</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
